import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import AccountClientRequests from '@api/requests';

import { AuthStateType } from './auth.interfaces';

const initialState: AuthStateType = {
	isLoggedIn: false,
	currentUser: undefined,
	tokens: undefined,
	verifyPhone: {
		type: undefined,
		expires_at: undefined,
	},
	verifyEmail: {
		expires_at: undefined,
	},
	resetPassword: {
		auth_form_slug: undefined,
		code_type: undefined,
		contact: undefined,
		reset_type: undefined,
		sentTime: undefined,
	},
};

export const { actions: authActions, reducer: authReducer } = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setVerifyPhoneType(state, action: PayloadAction<'sms' | 'voice' | undefined>) {
			state.verifyPhone.type = action.payload;
		},
		setPasswordReset(state, action) {
			state.resetPassword = {
				...state.resetPassword,
				...action.payload,
			};
		},
	},
	extraReducers: builder =>
		builder
			.addCase(AccountClientRequests.Auth.login.fulfilled, (state, { payload }) => {
				state.isLoggedIn = true;
				state.tokens = payload.login_basic.tokens;
				state.currentUser = payload.login_basic.user;
			})
			.addCase(AccountClientRequests.Auth.getBranches.fulfilled, (state, { payload }) => {
				if (state.currentUser) state.currentUser = { ...state.currentUser, branches: payload };
			})
			.addCase(AccountClientRequests.Auth.refreshToken.fulfilled, (state, { payload }) => {
				state.tokens = payload.login_basic.tokens;
			})
			.addCase(AccountClientRequests.Auth.refreshToken.rejected, state => {
				state.isLoggedIn = initialState.isLoggedIn;
				state.currentUser = initialState.currentUser;
				state.tokens = initialState.tokens;
			})
			.addCase(AccountClientRequests.Users.update.fulfilled, (state, { payload }) => {
				state.currentUser = { ...state.currentUser, ...payload.settings };
			})
			.addCase(AccountClientRequests.Users.verifyEmail.fulfilled, state => {
				if (state.currentUser) {
					state.tokens = initialState.tokens;
					state.currentUser.email_verified = true;
				}
			})
			.addCase(AccountClientRequests.Users.verifyPhone.fulfilled, state => {
				if (state.currentUser) {
					state.tokens = initialState.tokens;
					state.currentUser.phone_verified = true;
				}
			})
			.addCase(AccountClientRequests.Auth.logout.fulfilled, state => {
				state.isLoggedIn = initialState.isLoggedIn;
				state.currentUser = initialState.currentUser;
				state.tokens = initialState.tokens;
				state.verifyEmail = initialState.verifyEmail;
				state.resetPassword = initialState.resetPassword;
			})
			.addCase(AccountClientRequests.Auth.sendResetPasswordCode.fulfilled, state => {
				state.resetPassword = {
					...state.resetPassword,
					sentTime: Date.now(),
				};
			})
			.addCase(AccountClientRequests.Auth.resetPassword.fulfilled, state => {
				state.resetPassword = initialState.resetPassword;
			})
			.addCase(AccountClientRequests.MFA.toggleMFA.fulfilled, (state, { payload }) => {
				state.currentUser = { ...state.currentUser, ...payload.settings };
				state.tokens = payload.login_basic.tokens;
			}),
});
